import {BaseModel} from '@/models/base.model.js'

/**
 * Channel model
 */
export class Channel extends BaseModel {

  //Channel initials (made from name)
  get initials() {
    return this.name
      .split(' ')
      .map(word => word[0])
      .join('')
      .slice(0, 2)
      .toUpperCase()
  }
}
